import React from 'react';
import { useParams } from 'react-router-dom';
import SEO from '../../components/SEO';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import HeroSection from '../../components/hero/hero';
import WhatWeDo from '../../components/whatWeDo/WhatWeDo';
import { getCityContent } from '../../utils/cityContent';

function CityPage() {
    const { cityName: citySlug } = useParams();
    const currentCityData = getCityContent(citySlug);

    return (
        <div>
            {currentCityData && (
                <SEO
                    title={currentCityData.seoTitle}
                    description={currentCityData.seoDescription}
                    schemaData={currentCityData.faqSchema}
                    path={`/locations/${citySlug}`}
                />
            )}
            <Navbar links={true} />
            {currentCityData ? (
                <HeroSection currentCityData={currentCityData} />
            ) : (
                <div className="py-20 text-center"><h1 className="text-2xl font-bold">City not found!</h1></div>
            )}
            <WhatWeDo />
            <Footer />
        </div>
    );
}

export default CityPage;
